import { SyntheticEvent } from 'react';

import { DutyHourType, DutyHourTypeDynFlag, DutyHourTypeFlag } from 'generated';
import { Control, Controller } from 'react-hook-form';

import DutyHourTypeSelector from 'components/shared/DutyHourTypeSelector';

type Props = {
  control: Control<any>;
  name: string;
  onChange?: (
    event: SyntheticEvent<Element, Event>,
    dht?: DutyHourType | DutyHourType[]
  ) => void;
  label: string;
  required?: boolean;
  value?: number;
  variant?: 'standard' | 'filled' | 'outlined';
  referenceDate?: Date;
  fullWidth?: boolean;
  filterDutyHourTypeDynFlags?: DutyHourTypeDynFlag[];
  filterDutyHourTypeFlags?: DutyHourTypeFlag[];
  checkRestrictedAuthorization?: boolean;
  disabled?: boolean;
};

export type Option = {
  id?: number;
  value?: number;
  label: string;
  description?: string;
  code?: string;
};

const ControlledDutyHourTypeSelector = (props: Props) => {
  const {
    control,
    name,
    label,
    required,
    fullWidth,
    filterDutyHourTypeDynFlags,
    filterDutyHourTypeFlags,
    referenceDate,
    variant = 'outlined',
    checkRestrictedAuthorization,
    disabled
  } = props;
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <DutyHourTypeSelector
          field={field}
          fieldState={fieldState}
          label={label}
          required={required}
          fullWidth={fullWidth}
          filterDutyHourTypeDynFlags={filterDutyHourTypeDynFlags}
          filterDutyHourTypeFlags={filterDutyHourTypeFlags}
          referenceDate={referenceDate}
          variant={variant}
          checkRestrictedAuthorization={checkRestrictedAuthorization}
          disabled={disabled}
        />
      )}
    />
  );
};

export default ControlledDutyHourTypeSelector;
